export default {
    props: [
        'designId',
    ],

    computed: {
        designRecord() {
            return this.$store.state['submittalDesign'].records[this.designId];
        },
    },

    mounted() {
        if (!this.designRecord && this.designId) {
            this.$store.dispatch('submittalDesign/show', { id: this.designId })
        }
    },
};
